import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UserProfileComponent } from '../user-profile.component';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';

@Component({
  selector: 'app-resend-invitation',
  templateUrl: './resend-invitation.component.html',
  styleUrls: ['./resend-invitation.component.scss'],
})
export class ResendInvitationComponent {
  @Input() siteId!: string;
  @Input() email!: string;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  constructor(
    public dialogRef: MatDialogRef<UserProfileComponent>,
    private translate: TranslateService,
    private userManagementService: UserManagementService,
    private notificationService: NotificationService) {
      
    }
  resend(): void {
    this.userManagementService.resendInvitationEmail(this.siteId, this.email).subscribe({
    next: (success) => {
      if (success) {
        this.stepperChange.emit(12);
      }
    },
    error: (err) => {
      if (window.__dev__) console.log('submitToParent', err);
      this.notificationService.showError(err.message);
    },
  });
  }

  cancel(): void {
    this.stepperChange.emit(1); // Go back one step
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }
}
